export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    fixed: 'right',
    width: 80,
    slots: { default: 'opt', },
  },
  {
    title: that.$l('INDEX.table_label_originalFileName') || '原始文件名',
    field: 'originalFileName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 300,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_storeName') || '店铺名称',
    field: 'storeName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 200,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_processFlag') || '文件处理标记',
    field: 'processFlag',
    width: 140,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'processFlag' }
  },
  {
    title: that.$l('INDEX.table_label_processMessage') || '处理结果',
    field: 'processMessage',
    headerAlign: 'center',
    align: 'left',
    minWidth: 250,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_processDatetime') || '文件处理时间',
    field: 'processDatetime',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_uploadBy') || '上传人',
    field: 'createdByName',
    align: 'center',
    width: 140,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_uploadDate') || '上传时间',
    field: 'creationTime',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'updatedByName',
    align: 'center',
    width: 140,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'updatedTime',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
  },
]
